export default __webpack_public_path__ + "static/media/export-as-png-container-post.fdccb7db.png";